module.exports = __webpack_public_path__ + "img/2.8478da6.svg";